<template>
  <div class="navbar">
    <f7-navbar class="navbar-container">
      <f7-nav-left
        class="navbar_right"
        :style="{ 'background-color': customization.mainColor }"
      >
        <a href="#" data-panel="left" class="open-panel" @click="onMenuRight">
          <div class="navbar_right">
            <span
              class="icon-customer-app icon-menu"
              style="padding: 17.5px 0px 0px;display: block;color: rgb(215, 25, 33);font-size: 24px;"
              :style="{ color: customization.iconColor }"
            ></span>
          </div>
        </a>
      </f7-nav-left>
      <f7-nav-center class="navbar-center">
        <div class="logo_text">
          <div style="display: flex; justify-content: center;">
            <img v-if="isLogoShowed" :src="logo" class="" />
            <div
              v-if="!isLogoShowed"
              class="salesperson-name"
              @click="redirectToSiteUrl('home')"
            >
              <div style="color:#7F7F7F">{{ SalesPersonFirst }}</div>
              <div style="color:black">{{ SalesPersonLast }}</div>
            </div>
          </div>
        </div>
      </f7-nav-center>
      <f7-nav-right>
        <a href="#" data-panel="right" class="open-panel" @click="onMenuLeft">
          <div class="navbar_right graybg">
            <img
              v-if="!customerUser.profilePhoto"
              src="/static/images/icons/black/user.png"
              alt=""
              title=""
            />
            <img
              v-if="customerUser.profilePhoto"
              :src="customerUser.profilePhoto"
              class="navbar-avatar"
              alt=""
              title=""
            />
          </div>
        </a>
      </f7-nav-right>
    </f7-navbar>
    <div class="panel-overlay nav-position-fixed" @click="clearMargin"></div>

    <f7-panel
      right
      cover
      layout="light"
      :style="{ 'background-color': customization.mainColor }"
      class="nav-position-fixed right_nav"
    >
      <div class="rightContainer">
        <div class="user_login_info">
          <div class="user_thumb">
            <img :src="imageUrl" alt="" title="" />
            <div class="user_details">
              <p :style="{ color: customization.fontColor }">
                Welcome,
                <span style="color:#fff">{{
                  customerUser.firstName + " " + customerUser.lastName
                }}</span>
              </p>
            </div>
            <a :href="customerUser.isDemoUser ? '#' : 'edit-user-profile/'">
              <div class="user_avatar">
                <img
                  :src="
                    customerUser.profilePhoto
                      ? customerUser.profilePhoto
                      : '/static/images/avatar.jpg'
                  "
                  alt=""
                  title=""
                />
              </div>
            </a>
          </div>
          <nav class="user-nav">
            <ul>

              <li :style="{ 'border-bottom-color': customization.iconColor }">
                <a
                  :href="customerUser.isDemoUser ? '#' : 'edit-user-profile'"
                  class="close-panel"
                  @click="clearMargin"
                >
                  <span
                    class="dbc-icon dbc-icon-user-circle"
                    :style="{ color: customization.iconColor }"
                  ></span>
                  <span
                    :style="{
                      color: customization.fontColor,
                      'font-size': '16px',
                    }"
                    class="right-nav-span"
                    >My Profile</span
                  >
                </a>
              </li>

              <li
                v-if="videoMessageCount != 0"
                :style="{ 'border-bottom-color': customization.iconColor }"
              >
                <a href="video-message" class="close-panel">
                  <span
                    class="dbc-icon dbc-icon-video"
                    :style="{ color: customization.iconColor }"
                  ></span>
                  <span
                    :style="{
                      color: customization.fontColor,
                      'font-size': '16px',
                    }"
                    class="right-nav-span"
                    >Video Messages</span
                  >
                </a>
                <span
                  class="badge"
                  :style="{
                    color: customization.mainColor,
                    'background-color': customization.iconColor,
                  }"
                  >{{ videoMessageCount }}</span
                >
              </li>

              <li
                v-if="slsPermission.recommendAFriend"
                :style="{ 'border-bottom-color': customization.iconColor }"
              >
                <a
                  href="recommendfriend"
                  @click="setPageShare(SharepageEnum.history)"
                  class="close-panel"
                >
                  <span
                    class="dbc-icon dbc-icon-users-three"
                    :style="{ color: customization.iconColor }"
                  ></span>
                  <span
                    :style="{
                      color: customization.fontColor,
                      'font-size': '16px',
                    }"
                    class="right-nav-span"
                    >Refer</span
                  >
                </a>
                <span
                  class="badge"
                  :style="{
                    color: customization.mainColor,
                    'background-color': customization.iconColor,
                  }"
                  >{{ referralsCount }}</span
                >
              </li>
            </ul>
          </nav>
        </div>
        <div style="padding-left: 9%;" class="termContainer">
          <a href="terms" class="close-panel"> Terms and Conditions </a>
          <span :style="{ color: customization.fontColor }">and</span>
          <a href="policy" class="close-panel"> Privacy Policy </a>
        </div>
      </div>
    </f7-panel>

    <f7-panel
      left
      cover
      layout="light"
      class="nav-position-fixed left_nav"
      :style="{ 'background-color': customization.mainColor }"
    >
      <nav
        class="icons_31"
        v-bind:class="
          customization.navMenuId === 1 ? 'sidebar-nav' : 'main-nav'
        "
      >
        <list-menu-component
          v-if="customization.navMenuId === 1"
          :items="customButtons"
          :fontColor="customization.fontColor"
          :iconColor="customization.iconColor"
          @onClick="OnItemClick($event)"
        ></list-menu-component>
        <grid-menu-component
          v-else
          :items="customButtons"
          :fontColor="customization.fontColor"
          :iconColor="customization.iconColor"
          @onClick="OnItemClick($event)"
        >
        </grid-menu-component>
      </nav>
    </f7-panel>
  </div>
</template>

<script>
/* eslint-disable */

import { mapState, mapGetters, mapActions } from "vuex";
import { Request } from "../shared/base.requests";
import config from "../../config/customer.api";
import iconHelper from "../helpers/menu.icon.helper";
import ListMenuComponent from "./home-page-components/list-menu-component.vue";
import GridMenuComponent from "./home-page-components/grid-menu-component.vue";
import { MenuItemsEnum } from "../shared/enums/menu.items";
import { PAGES } from "../shared/routes.constants";
import {referralsCounterHelper} from '@/helpers/referral-history.helper'
export default {
  components: { ListMenuComponent, GridMenuComponent },
  name: "bc-navbar",
  beforeCreate() {
    if (this.$store.state.login.isAuthorized) {
      Request.get(config.videoMessagesCount)
        .then((response) => {
          this.videoMessageCount = response;
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  props: {
    title: {
      type: String,
      default: "Navbar",
    },
    backLink: {
      type: Boolean,
      default: false,
    },
    noRightMenu: {
      type: Boolean,
      default: false,
    },
    showLogo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      menuItems: {
        Dashboard: "/dashboard/",
        Account: "/account/overview/",
      },
      isLogoShowed: true,
      videoMessageCount: 0,
      hideTopNav: false,
    };
  },
  mounted: function() {
    this.clearMargin();
    if (this.isHomePage) {
      this.isLogoShowed = true;
    } else {
      this.isLogoShowed = false;
    }
    if (this.company == null && this.isAuth == true)
      this.$store.dispatch("aboutCompany/loadDataByCompany").catch((x) => {
        this.$f7.mainView.router.load({
          url: "error",
        });
      });
  },
  methods: {
    ...mapActions("customPage", ["loadCustomPage"]),
    getIconClass(iconId) {
      return iconHelper.getIconClassById(iconId);
    },
    HideTopNav() {
      var result = this.isHomePage && this.customization.homePageMenuId == 3;
      if (result == true) {
        $("div.page-content").css("paddingTop", 0);
        $("div.navbar").css("height", 0);
      } else {
        $("div.page-content").css("paddingTop", 56);
        $("div.navbar").css("height", 56);
      }
      return result;
    },
    HasInventory() {
      if (this.company != null) return this.company.hasInventory == true;
      else return false;
    },
    IsVisible_li(b) {
      if (b.iconSystemId === MenuItemsEnum.Shop && this.HasInventory() == false)
        return false;
      if (
        b.iconSystemId === MenuItemsEnum.VideoMessage &&
        this.videoMessageCount == 0
      )
        return false;
      if (
        b.iconSystemId === MenuItemsEnum.Map &&
        this.company != null &&
        this.company.adress == null
      )
        return false;
      return true;
    },
    OnItemClick(b) {
      if (b.iconSystemId === MenuItemsEnum.Home && this.isHomePage) {
        this.clearMargin();
      }
      if (b.hasActivity && b.name != null) this.LogActivity(b.name);
      if (b.isClearMargin) this.clearMargin();
      if (b.iconSystemId === MenuItemsEnum.SocialMedia)
        this.setPage(this.pageEnum.Socials);
      if (b.iconSystemId === MenuItemsEnum.About)
        this.setPage(this.pageEnum.Media);
      if (
        b.iconSystemId === MenuItemsEnum.Phone ||
        b.iconSystemId === MenuItemsEnum.Email ||
        b.iconSystemId === MenuItemsEnum.Text
      )
        this.redirectW(b.url);
      if (b.iconSystemId === MenuItemsEnum.ShareToFriends)
        this.setPageShare(this.SharepageEnum.share);
      if (b.iconSystemId == MenuItemsEnum.AddToPhone) {
        this.LoadVCard();
        return;
      }
      if (b.iconSystemId == MenuItemsEnum.MyReferrals) {
        return this.$router.load({
          url: b.url + `/${PAGES.Referrals}`,
        });
      }
      if (this.isExternal(b)) {
        var win = window.open(b.url, "_blank");
        win.focus();
      } else {
        if (b.type === 3) {
          console.log(b.url.split("/"));
          this.loadCustomPage(b.url.split("/")[1]).then(
            this.$router.load({
              url: b.url,
            })
          );
        } else {
        }
        this.$router.load({
          url: b.url,
        });
      }
    },
    logOutClicked() {
      delete localStorage.token;
      sessionStorage.removeItem("last_location");
      // here, f7 router is unreliable. Use the browser API!
      window.location.replace("/#!//dashboard/");
      window.location.reload(true);
      // this.$f7.mainView.router.load({url: '/'})
    },
    LoadVCard() {
      this.clearMargin();
      var url = config.downloadVCF + "/" + this.salesGlobalId;
      var win = window.open(url, "_blank");
      win.focus();
    },
    setPage(args) {
      this.$store.dispatch("about/setPageAbout", args);
    },
    setPageShare(args) {
      this.$store.dispatch("recommendFriend/setPage", args);
    },
    redirectTo(url) {
      this.clearMargin();
      // if(url)
      // document.location.href = url;
    },
    redirectToSiteUrl(Url) {
      this.clearMargin();
      this.$router.load({
        url: Url,
      });
    },
    LogActivity(type) {
      if (type != null) Request.get(config.logCustomerActivity + type);
    },
    redirectW(url) {
      if (url) document.location.href = url;
    },
    onMenuLeft() {
      this.clearMargin();
      if (this.isHomePage) {
        var elem = document.getElementsByClassName("navbar-container");
        var elem2 = document.getElementsByClassName("right_nav")[0];
        var width = document.defaultView
          .getComputedStyle(elem2, null)
          .getPropertyValue("width");
        if (elem && elem.length != 0) {
          elem[0].style.marginLeft = "-" + width;
          if (elem.length > 1) {
            elem[1].style.marginLeft = "-" + width;
          }
        }
        var elem = document.getElementsByClassName("pagepage");
        if (elem && elem.length != 0) {
          elem[0].style.transform = "translateX(-" + width + ")";
          if (elem.length > 1) {
            elem[1].style.transform = "translateX(-" + width + ")";
          }
        }
      }
    },
    onMenuRight() {
      this.clearMargin();
      if (this.isHomePage) {
        var elem = document.getElementsByClassName("navbar-container");
        var elem2 = document.getElementsByClassName("left_nav")[0];
        var width = document.defaultView
          .getComputedStyle(elem2, null)
          .getPropertyValue("width");
        if (elem && elem.length != 0) {
          elem[0].style.marginLeft = width;
          if (elem.length > 1) {
            elem[1].style.marginLeft = width;
          }
        }
        var elem = document.getElementsByClassName("pagepage");
        if (elem && elem.length != 0) {
          elem[0].style.transform = "translateX(" + width + ")";
          if (elem.length > 1) {
            elem[1].style.transform = "translateX(" + width + ")";
          }
        }
      }
    },
    clearMargin() {
      var elem = document.getElementsByClassName("navbar-container");
      if (elem && elem.length != 0) {
        elem[0].style.marginLeft = "0";
        elem[0].style.marginLeft = "0";
        if (elem.length > 1) {
          elem[1].style.marginLeft = "0";
          elem[1].style.marginLeft = "0";
        }
      }
      var elem = document.getElementsByClassName("pagepage");
      if (elem && elem.length != 0) {
        elem[0].style.transform = "translateX(0)";
        elem[0].style.transform = "translateX(0)";
        if (elem.length > 1) {
          elem[1].style.transform = "translateX(0)";
          elem[1].style.transform = "translateX(0)";
        }
      }
    },
    showBrowser() {
      var ua = navigator.userAgent,
        tem,
        M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return "IE " + (tem[1] || "");
      }
      if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null)
          return tem
            .slice(1)
            .join(" ")
            .replace("OPR", "Opera");
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M[0];
    },
    mobileCheck() {
      var check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor);
      return check;
    },
    isRunningStandalone() {
      return window.matchMedia("(display-mode: standalone)").matches;
    },
    isExternal(button) {
      const urlReg = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&/=]*)/g;
      return urlReg.test(button.url);
    },
  },
  computed: {
    ...mapState("policies", ["policies"]),
    ...mapState("agents", ["currentAgents"]),
    ...mapGetters("claims", ["openClaims"]),
    ...mapGetters("common", ["customButtons"]),
    ...mapState({
      pageEnum: (state) => state.about.pagesEnum,
      logo: (state) => state.common.logo,
      customerUser: (state) => state.editUserProfile.customerUser,
      SalesPersonFirst: (state) =>
        state.common.salesPersonFullName.split(" ")[0],
      SalesPersonLast: (state) =>
        state.common.salesPersonFullName
          .split(" ")
          .splice(1)
          .join(""),
      imageUrl: (state) => state.common.companyMainImage,
      SharepageEnum: (state) => state.recommendFriend.pageEnum,
      company: (state) => state.aboutCompany.companyData,
      salesPersonPhone: (state) => state.common.phone,
      isAuth: (state) => state.login.isAuthorized,
      SalesSiteUrl: (state) => state.common.salesSite,
      slsPermission: (state) => state.common.slsPermission,
      industryId: (state) => state.common.industryId,
      salesGlobalId: (state) => state.common.salesGlobalId,
      inventoryId: (state) => state.common.inventoryId,
      customization: (state) => state.common.customization,
      referralsCount: (state) => referralsCounterHelper(state.recommendFriend.historyCount)
    }),
    claimsFeatureEnabled() {
      return this.setting("claims.claims_enabled");
    },
    isHomePage() {
      return (
        this.$route.route.path == ":tokenId/" ||
        this.$route.route.path == "home"
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "~styles/_variables.scss";

$navbar-height: 56px !default;

//  font generation
@font-face {
  font-family: "iconsCustomerApp";
  src: url("/static/fonts/iconsCustomerApp.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Glyphicons Regular";
  src: url("/static/fonts/glyphicons-regular.ttf") format("truetype"),
    url("/static/fonts/glyphicons-regular.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

.glyphicons {
  font-family: "Glyphicons Regular";
  font-size: 34px;
}

.navbar {
  background: #fff !important;
}

.navbar-center {
  width: 100%;
  color: $color-primary;
  margin: 0;
  font-family: $title-font-family;
  font-weight: $title-font-weight;
  font-size: $title-font-size;
  text-transform: $title-text-transform;
  box-shadow: none;
}

.navbar {
  box-shadow: 0 1px 4px -1px rgba(0, 0, 0, 0.35);
  color: $color-primary;
}

.navbar-center--no-back-link {
  margin-left: 16px;
  margin-right: 0;
}

.navbar-center__text-column {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.navbar-center__text {
  display: inline-block;
  vertical-align: middle;
  font-size: 20px;
  line-height: $navbar-height;
}

.navbar-center__logo-column {
  height: $navbar-height;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.navbar-center__logo {
  line-height: $navbar-height;
  max-height: 42px;
  align-self: center;
}

.navbar-right {
  margin-left: 0;
}

.navbar-right--empty {
  margin-right: 1em;
}

.navbar-container {
  background-color: $color-white;
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  transition-duration: 0.3s;
}

.navbar__icon {
  color: $color-primary;
  font-size: 26px;
}

.nav-position-fixed {
  position: fixed;
}

.slider-caption {
  position: relative;
  z-index: 9;
}

.salesperson-name {
  display: flex;
  padding-left: 20px;
  text-transform: none;
}

.navbar-avatar {
  border-radius: 50%;
  max-width: 60%;
  padding: 0px;
  margin-top: 19%;
  height: 60%;
  width: 60%;
  object-fit: cover;
}

.rightContainer {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.termContainer {
  padding: 15px;
  font-size: 15px;
  margin-top: auto;
  text-align: center;
}

.list-icon {
  flex-basis: 55px;
  padding: 12px 0;
}

.right-nav-span {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// navbar.vue?5887a0c7